import { styled, Box, Typography, Button } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '20px 20px 0',

  [theme.breakpoints.down(700)]: {
    flexDirection: 'column',
    gap: 5,
    alignItems: 'flex-start',
  },
}));
export const Bold = styled('span')(({ theme }) => ({
  fontWeight: 700,
  color: COLORS.PRIMARY,
}));

export const HeaderRight = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 20,

  [theme.breakpoints.down(700)]: {
    flexDirection: 'column',
    gap: 5,
    alignItems: 'flex-start',
  },
}));

export const AddResumeButton = styled(Button)(({ theme }) => ({
  height: 40,
  border: '1px solid #3e8bff',
  maxWidth: 224,
  fontSize: 14,
  backgroundColor: 'transparent',
  '& svg': {
    width: 18,
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 25,
  flex: 1,
}));

export const ContentCont = styled(Box)(({ theme }) => ({}));

export const ModalCont = styled(Box)(({ theme }) => ({
  width: 485,
  height: 340,
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ButtonCont = styled(Box)(({ theme }) => ({
  marginTop: 36,
  display: 'flex',
  justifyContent: 'space-between',
  width: 380,
}));

export const SelectButton = styled(Button)(({ theme }) => ({
  width: 165,
  height: 44,
  backgroundColor: '#3e8bff',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: 165,
  height: 44,
  border: 'solid 1px #3e8bff',
}));

export const Select = styled('select')(({ theme }) => ({
  color: 'white',
  width: 380,
  height: 50,
  paddingLeft: 10,
  backgroundColor: theme.palette.type === 'dark' ? '#151a21' : '#edf1f6',
}));

export const Option = styled('option')(({ theme }) => ({
  fontSize: 15,
}));

export const CheckboxContainer = styled('div')(({ theme }) => ({
  letterSpacing: 0.4,

  '& .MuiTypography-root': {
    fontSize: 14,
  },

  '&.MuiFormControlLabel-root': {
    margin: 0,
  },

  '& label': {
    margin: 0,

    [theme.breakpoints.down(700)]: {
      marginLeft: -7,
    },
  },
}));
